import { html, slotted } from "@microsoft/fast-element";
export function menuTemplate() {
    return html `
    <template
      slot="${(x) => (x.slot ? x.slot : x.isNestedMenu() ? "submenu" : void 0)}"
      @keydown="${(x, c) => x.handleMenuKeyDown(c.event)}"
      @focusout="${(x, c) => x.handleFocusOut(c.event)}"
    >
      <slot ${slotted("items")}></slot>
    </template>
  `;
}
export const template = menuTemplate();
//# sourceMappingURL=menu-list.template.js.map